import { render } from "./Positions.vue?vue&type=template&id=688840aa&scoped=true"
import script from "./Positions.vue?vue&type=script&lang=ts"
export * from "./Positions.vue?vue&type=script&lang=ts"

import "./Positions.vue?vue&type=style&index=0&id=688840aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-688840aa"

export default script